module.exports = __webpack_public_path__ + "img/ribbon_width.3c47a00d.svg";